import React, { SVGProps } from 'react';

/* eslint-disable max-len */
const SvgEye: React.FunctionComponent<SVGProps<SVGSVGElement>> = props => (
  <svg viewBox="0 0 30 30" {...props}>
    <circle cx={29} cy={15} r={1} />
    <circle cx={1} cy={15} r={1} />
    <circle cx={15} cy={15} r={3} />
    <path d="M29.8 14.4S24 5 15 5 .2 14.4.2 14.4l-.04 1.14S5 25 15 25s14.84-9.46 14.84-9.46l-.04-1.13zM15 22a7 7 0 1 1 0-14 7 7 0 0 1 0 14z" />
  </svg>
);
/* eslint-enable max-len */

export default SvgEye;
